module.exports = __webpack_public_path__ + "img/discord_settings.15a1f18d.jpg";